/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const VerifiedIcon = createIcon(
  '0 0 20 20',
  <path
    fillRule="evenodd"
    d="M12.5 3.5h4v4L19 10l-2.5 2.5v4h-4L10 19l-2.5-2.5h-4v-4L1 10l2.5-2.5v-4h4L10 1zM9 10.586 7.207 8.793l-1.414 1.414L9 13.414l5.707-5.707-1.414-1.414z"
    clipRule="evenodd"
  />,
);
